import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getFilterIndicator, getSortIndicator } from '@/lib/tableHelpers'
import MyProjectsTableRow from './MyProjectsTableRow'

export default function MyProjectsTable({
	data,
	loading,
	sortColumn,
	sortDirection,
	onSort,
	hasTrenerFilter,
	onOpenTrenerFilter,
}) {
	const { t } = useTranslation()
	const rows = Array.isArray(data) ? data : []

	const renderColumnHeader = ({ key, label, sortable = true, hasFilter = false, onOpenFilter }) => {
		const columnLabel = sortable ? (
			<button
				type="button"
				className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
				onClick={() => onSort(key)}
			>
				{label}
				{getSortIndicator(key, sortColumn, sortDirection)}
			</button>
		) : (
			<span className="font-semibold text-gray-700">{label}</span>
		)

		if (!onOpenFilter) return columnLabel

		return (
			<div className="inline-flex items-center gap-1">
				{columnLabel}
				<button
					type="button"
					className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
					onClick={onOpenFilter}
					title={t('myProjects.list.tooltips.filterColumn', { defaultValue: t('myTrainings.list.tooltips.filterColumn') })}
				>
					{getFilterIndicator(hasFilter)}
				</button>
			</div>
		)
	}

	if (loading) return <LoadingIndicator />

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							{renderColumnHeader({
								key: 'data_rozpoczecia',
								label: t('myProjects.list.table.startDate', {
									defaultValue: t('projects.list.table.startDate', { defaultValue: 'Data rozpoczęcia' }),
								}),
							})}
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							{renderColumnHeader({
								key: 'nazwa',
								label: t('myProjects.list.table.nazwa', { defaultValue: 'Nazwa' }),
							})}
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							{renderColumnHeader({
								key: 'trainerName',
								label: t('myProjects.list.table.trainerName', { defaultValue: 'Trener' }),
								sortable: false,
								hasFilter: hasTrenerFilter,
								onOpenFilter: onOpenTrenerFilter,
							})}
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							{renderColumnHeader({
								key: 'stepsCount',
								label: t('myProjects.list.table.stepsCount', { defaultValue: 'Etapy' }),
								sortable: false,
							})}
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map(project => (
						<MyProjectsTableRow
							key={project._id}
							project={project}
						/>
					))}
				</tbody>
			</table>
			{rows.length === 0 ? (
				<div className="py-4">
					<NoResultsIndicator
						message={t('myProjects.list.emptyState.title', { defaultValue: 'Brak projektów' })}
						description={t('myProjects.list.emptyState.description', { defaultValue: 'Brak projektów dla wybranych filtrów.' })}
					/>
				</div>
			) : null}
		</div>
	)
}
